import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { EntraSettings } from '../auth/msal.ts';
import { ToastProvider } from '../ui/toast.tsx';

export interface RouterContext {
  /** Null when the build has no Entra ids; /login then reports a `config` error on sign-in. */
  readonly entra: EntraSettings | null;
  readonly queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout(): React.JSX.Element {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
